<template>
    <b-alert :show="!isLoading && !hasCookie" dismissible block bottom class="fixed-bottom" style="margin-bottom: 0">
        <b-row class="justify-content-md-center">
            <b-col lg="11" s="10">{{ blurb }}</b-col>
            <b-col lg="1" s="2" class="text-center"><b-button variant="dark" size="sm" @click="setCookie">Ok</b-button></b-col>
        </b-row>
    </b-alert>
</template>
<script>

/* eslint-disable */
'use strict'

import service from "@/service/service";
import utils from "@/utils/utils";

export default {
    name: "CookieBanner",
    data() {
        return {
            debug: false,
            error: false,
            isLoading: true,
            hasCookie: false,
            code: 'cookie_message',  // blurbs.code
            blurb: 'This site uses cookies.'
        }
    },
    computed: {
        showBanner() {
            let aout = !this.isLoading && !this.hasCookie
            if (this.debug) console.log( `showBanner: ${aout}`)
            return aout
        }
    },
    methods: {
        setCookie(e) {
            this.hasCookie = true
            utils.setVivaCookie()
            if (this.debug) console.log('Set Viva Cookie.')
        }
    },
    created() {
        this.hasCookie = utils.hasVivaCookie()    // check storage
    },
    mounted() {
        if (this.debug) console.log(`isLoading: ${this.isLoading}  hasCookie ${this.hasCookie}`)
        if (!this.hasCookie) {
            service
                .getBlurb(this.code)
                .then(
                    (res => {
                        // if (this.debug) console.log(res);
                        if (res.status && res.rowCount !== 0) {
                            this.blurb = res.data[0].blurb
                        }
                        else {
                            this.error = true
                        }
                    }).bind(this)
                )
                .finally(e => {
                    this.isLoading = false
                    if (this.debug) console.log(`isLoading: ${this.isLoading}  hasCookie ${this.hasCookie}  buttonClicked: ${this.buttonClicked}`)
                 })
                .catch(e => {
                    this.error = true
                    console.log(e)
                })
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CookieBanner.vue